import { z } from 'zod/v4';

// `allowed_origins.id` is `varchar(36)`. Legacy accepted any array items; a
// longer or non-string id cannot match a row, so it is a 400 now.
export const AdminBulkDeleteAllowedOriginsBodySchema = z.object({
  ids: z.array(z.string().min(1).max(36)).min(1),
});

export type AdminBulkDeleteAllowedOriginsBody = z.infer<
  typeof AdminBulkDeleteAllowedOriginsBodySchema
>;
